import type { CartAdapter } from "@app/types/checkout-cart-adapter-types";
import type {
  EmptyExternalInstallments,
  ExternalInstallments,
  InternalInstallments
} from "@app/types/checkout-types";

export function isInternalInstallments(
  installments: CartAdapter["charges"]["installments"]
): installments is InternalInstallments {
  return installments ? installments.type === "internal_plans" : false;
}

export function isExternalInstallments(
  installments: CartAdapter["charges"]["installments"]
): installments is ExternalInstallments {
  if (installments && "plan_id" in installments) {
    return (
      !!installments.plan_id &&
      !!installments.installment_amount &&
      !!installments.total_amount
    );
  }
  return false;
}

export function isEmptyExternalInstallments(
  installments: CartAdapter["charges"]["installments"]
): installments is EmptyExternalInstallments {
  if (installments && "plan_id" in installments) {
    return (
      !installments.plan_id &&
      !installments.installment_amount &&
      !installments.total_amount
    );
  }
  return false;
}
